import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminChatOptions = (params) => {
  return axiosClient.post("/api/admin/im/options", params).then((r) => r.data);
};
